import React from "react";
import { Phone, Mail, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { company } from "../mock";
import Editable from "./Editable";

export default function CallToActionBanner() {
  return (
    <section className="relative overflow-hidden" style={{ background: "linear-gradient(115deg, var(--brand-700) 0%, var(--brand-600) 60%, var(--brand-500) 100%)" }}>
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: "radial-gradient(circle at 80% 30%, rgba(255,255,255,0.4), transparent 30%)" }} />
      <div className="relative max-w-7xl mx-auto px-6 py-14 md:py-16 grid md:grid-cols-3 gap-8 text-white">
        <div className="md:col-span-2">
          <Editable field="cta.overline" as="p" className="text-sm uppercase tracking-[0.25em] text-white/70 mb-3">Call Us or Fill the Form</Editable>
          <Editable field="cta.headline" as="h2" className="font-display text-3xl md:text-4xl font-bold leading-tight" multiline>
            Need a quote on bulk raw materials? Our trade desk responds within one business day.
          </Editable>
        </div>
        <div className="flex flex-col gap-4 justify-center">
          <a href={`tel:${company.phone}`} className="flex items-center gap-3 text-white/95 hover:text-white">
            <span className="w-10 h-10 rounded-full bg-white/10 border border-white/25 flex items-center justify-center"><Phone size={16} /></span>
            <span><span className="block text-xs text-white/60 uppercase tracking-wider">Call us</span><span className="text-base font-semibold">{company.phone}</span></span>
          </a>
          <a href={`mailto:${company.email}`} className="flex items-center gap-3 text-white/95 hover:text-white">
            <span className="w-10 h-10 rounded-full bg-white/10 border border-white/25 flex items-center justify-center"><Mail size={16} /></span>
            <span><span className="block text-xs text-white/60 uppercase tracking-wider">Email us</span><span className="text-base font-semibold">{company.email}</span></span>
          </a>
          <Link to="/contact-us">
            <Button className="bg-white text-brand hover:bg-white/90 rounded-md h-11 px-6 font-medium" style={{ color: "var(--brand-700)" }}>Get a Quote</Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
